import { defineComponent as _defineComponent } from 'vue'
import TheTopbar from "@/components/shell/top-bar.vue";
import { auth0 } from "@/services/auth.service";
import { onMounted, ref, watch } from 'vue';
import LoadingModal from "@/components/common/loading-modal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'app-shell',
  setup(__props, { expose: __expose }) {
  __expose();

const isLoading = ref(auth0.isLoading.value);

watch(auth0.isLoading, (newVal) => {
  isLoading.value = newVal;
});

onMounted(() => {
  // Check if the user is authenticated
  if (!auth0.isAuthenticated.value) {
    // Redirect to the login page
    auth0.loginWithRedirect();
  }
});


const __returned__ = { isLoading, TheTopbar, LoadingModal }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})